<template>
  <div class="edit-visit-record-container">
    <div class="page-header">
      <h2>编辑回访记录</h2>
    </div>
    
    <el-card>
      <visit-record-form :record-id="recordId" />
    </el-card>
  </div>
</template>

<script>
import VisitRecordForm from '../components/VisitRecordForm'

export default {
  name: 'EditVisitRecord',
  components: {
    VisitRecordForm
  },
  computed: {
    recordId() {
      return parseInt(this.$route.params.id)
    }
  }
}
</script>

<style scoped>
.edit-visit-record-container {
  width: 100%;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #333;
}
</style>